import {defineAsyncComponent} from 'vue';
import popupUtil from '@/commons/popupUtil.js';

// Phiếu thu tiền
const caReceiptDetail = defineAsyncComponent(() => import('@/views/cash/caReceipt/CAReceiptDetail.vue'));
const caReceiptEnoughMoneyPopup = defineAsyncComponent(() =>
  import('@/views/cash/caReceipt/CAReceiptEnoughMoneyPopup.vue'),
);
// Phiếu chi tiền
const caPaymentDetail = defineAsyncComponent(() => import('@/views/cash/caPayment/CAPaymentDetail.vue'));
const caPaymentReceiptEnoughMoneyPopup = defineAsyncComponent(() =>
  import('@/views/cash/caPayment/CAPaymentReceiptEnoughMoneyPopup.vue'),
);

// Phiếu chi trả lương
const caPaymentSalaryDetail = defineAsyncComponent(() => import('@/views/cash/caPayment/CAPaymentSalaryDetail.vue'));
// Điều chỉnh kinh phí thu
const caAdjustReceiptDetail = defineAsyncComponent(() =>
  import('@/views/cash/caAdjustReceipt/CAAdjustReceiptDetail.vue'),
);
// Điều chỉnh kinh phí chi
const caAdjustPaymentDetail = defineAsyncComponent(() =>
  import('@/views/cash/caAdjustPayment/CAAdjustPaymentDetail.vue'),
);

// Bảng kiểm kê quỹ
const caFundInventoryDetail = defineAsyncComponent(() =>
  import('@/views/cash/caFundInventory/CAFundInventoryDetail.vue'),
);

// Bảng kiểm kê quỹ
const caHandleDiffMoney = defineAsyncComponent(() => import('@/views/cash/caFundInventory/CAHandleDiffMoney.vue'));

export function registerCA(app) {
  const registerConfig = {
    CAReceiptDetail: caReceiptDetail,
    CAPaymentSalaryDetail: caPaymentSalaryDetail,
    CAPaymentDetail: caPaymentDetail,
    CAAdjustReceiptDetail: caAdjustReceiptDetail,
    CAAdjustPaymentDetail: caAdjustPaymentDetail,
    CAPaymentReceiptEnoughMoneyPopup: caPaymentReceiptEnoughMoneyPopup,
    CAReceiptEnoughMoneyPopup: caReceiptEnoughMoneyPopup,
    CAFundInventoryDetail: caFundInventoryDetail,
    CAHandleDiffMoney: caHandleDiffMoney,
  };

  const keys = Object.keys(registerConfig);

  keys.filter(key => {
    app.component(key, registerConfig[key]);
  });

  popupUtil.registerPopup(keys, 'Cash');
}
